import { createFileRoute } from "@tanstack/react-router";
import { GreetingLanding } from "@/site/pages/greeting-landing";

// Legacy `/anniversary/gift` — the day-of "Send Own Anniversary" greeting
// (9,928 views / 90 days in legacy; had no route here until 2026-09-16).
export const Route = createFileRoute("/anniversary/gift")({
  component: () => <GreetingLanding occasion="anniversary" />,
});
